import { getEnvironmentApiUrls } from '@dvag/dfs-constant-config/api-urls';
import { getApiClient } from './api-client';

export type Policies = {
  policies: string[];
};

const getConfigurationBaseUrl = () =>
  getEnvironmentApiUrls().graphQl.configuration.replace(/\/graphql\/?$/, '');

export const getConfigurationService = () => {
  const baseURL = getConfigurationBaseUrl();

  const api = getApiClient(baseURL);

  const getPolicies = async () => {
    const response = await api.get<Policies>('/policies');
    return response.data;
  };

  return {
    getPolicies,
  };
};
